import { mapActions, mapGetters, mapMutations } from "vuex";

import LoadingReport from "./assets/LoadingReport";
import DialogFormFinishCalled from "./components/DialogForm.vue";

import SkeletonComponent from "@/components/Skeleton/Skeleton.vue";
import firebase from "@/firebase";
import ObjectValidator from '@/scripts/ObjectValidator';
import Utils from '@/scripts/Utils';
import Rules from "@/utils/Rules";
import InfiniteLoading from 'vue-infinite-loading';

import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";

export default {
    route: 'called',
    components: {
        DialogFormFinishCalled,
        SkeletonComponent,
        InfiniteLoading,
    },
    data: () => ({
        dialogAlert: false,
        isLoadingDelet: false,
        value: [],
        objCalled: [],
        showToOptions: [],
        showCheckBoxOptions: [],
        selectedSector: null,
        listSectors: null,
        listClients: null,
        columnsToChoose: ['Todos', 'Administrativo', 'Técnico', 'Em Aberto', 'Andamento', 'Concluído'],
        statusToChoose: ['Em Aberto', 'Andamento', 'Concluído'],
        erroMsg: '',
        flagErroMsg: false,
        usersClassVet: [],
        usersNames: [],
        superAdminNames: [],
        callsVet: [],
        callsVetView: [],
        itemsStatus: [],
        dialogView: false,
        CalledViewClick: { imageUser: null, nameUser: null, natureCalled: null, status: null, imageURL: null, description: null },
        dialogComment: false,
        colorComment: 'black',
        commentText: '',
        statusModel: '',
        dialogStatus: false,
        dialogFinishCalled: false,
        loadCalls: true,
        searchText: '',
        columnToSearch: '',
        callsVetViewFilter: '',

        dialog: false,
        viewDialog: false,
        titulo: '',
        image: '',
        imageUp: '',
        defaultImage:
            "data:image/jpeg;base64,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",
        testeImg:
            "data:image/jpeg;base64,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",

        headers: [],
        ...LoadingReport['data'],
        startDateDialog: false,
        endDateDialog: false,
        clientObject: null,
        listUnits: [],
        graphicButton: true,
        unitObject: null,
        validForm: true,
        isLoadingCreate: false,
        dialogFormFinishCalled: {},
        messages: 0,
        lastDocSnapshot: null,
        lastDocSnapshotComment: null,
        loadingComment: false,
        callsSizeIdentif: 0,
        commentCurrentIndex: [],
        infiniteId: +new Date(),
        loadingStatus: false,
        loadingOpenCalled: false,
        whereFilterSelectCalls: null,
        showInfiniteLoading: true,
    }),
    methods: {
        ...mapMutations(["OPEN_DIALOGALERT"]),
        ...mapActions([
            "getUnitsByUser",
        ]),
        ...LoadingReport['methods'],
        showDeleteDialogAlert,
        async infiniteHandler($state) {
            if (this.whereFilterSelectCalls) {
                const { result, calls, lastDocSnapshot } = await firebase.paginationCalls(this.lastDocSnapshot, this.whereFilterSelectCalls)
                this.lastDocSnapshot = lastDocSnapshot
                await this.calls(calls)
                if (result > 0) {
                    return $state.loaded()
                }
                return $state.complete()
            }
            const { result, calls, lastDocSnapshot } = await firebase.paginationCalls(this.lastDocSnapshot)
            this.lastDocSnapshot = lastDocSnapshot
            await this.calls(calls)
            if (result > 0) {
                return $state.loaded()
            }
            return $state.complete()
        },
        async infiniteHandlerComment($state) {
            let { result, list, lastDocSnapshot } = await firebase.paginationComments(
                this.CalledViewClick.idDoc || this.CalledViewClick.id,
                this.lastDocSnapshotComment)
            this.lastDocSnapshotComment = lastDocSnapshot
            await this.addImgComment(list)

            this.commentCurrentIndex.push(...list)

            if (result > 0) {
                return $state.loaded()
            }
            return $state.complete()
        },
        async deleteCall() {

            this.isLoadingDelet = true
            let id = this.CalledViewClick.idDoc || this.CalledViewClick.id
            await firebase.deleteCalls(id)
            let newVet = this.callsVet.filter((i) => (i.idDoc || i.id) !== id)
            this.callsVet = []
            await this.calls(newVet)
            this.isLoadingDelet = false
        },
        openClalledDialog() {
            this.objCalled = ObjectValidator.create('called')
            this.listClients = this.getClients
            this.titulo = "Novo chamado"
            this.objCalled.status = "Em aberto"
            this.itemsStatus = ["Em aberto"]
            this.dialog = true
        },
        async calls(calls) {
            this.callsVet.push(...calls)
            this.addRankCall()
            await this.showTo(this.getCurrentUserRank)
        },
        datePost(time) {
            if (time !== undefined) {
                return Utils.formatDateDayjs(new Date(time), 'DD/MM/YYYY [as] HH:mm')
            }
        },
        async filterCalls(select) {
            this.callsVetView = this.callsVetViewFilter
            switch (select) {
                case "Técnico":
                    // this.callsVetView = this.callsVetView.filter((i) => { return i.natureCalled == select })
                    this.whereFilterSelectCalls = {
                        nameParam: 'natureCalled',
                        param: 'Técnico'
                    }
                    break;
                case "Administrativo":
                    this.whereFilterSelectCalls = {
                        nameParam: 'natureCalled',
                        param: 'Administrativo'
                    }
                    break;
                case "Todos":
                    this.whereFilterSelectCalls = null
                    this.lastDocSnapshot = null
                    break;
                case "Andamento":
                    this.whereFilterSelectCalls = {
                        nameParam: 'status',
                        param: '#FF8300'
                    }
                    break;
                case "Concluído":
                    this.whereFilterSelectCalls = {
                        nameParam: 'status',
                        param: 'green'
                    }
                    break;
                case "Em Aberto":
                    this.whereFilterSelectCalls = {
                        nameParam: 'status',
                        param: 'red'
                    }
                    break;
                default:
                    break;
            }

        },
        async updateComment(idDoc, data) {
            try {
                this.loadingComment = true
                await firebase.updateCalls(idDoc, data)
                this.loadingComment = false
                await firebase.getCalls(idDoc)
            } catch (e) {
                console.error(e)
            }
        },
        async commentCalled() {
            //updateCalls(called)
            this.dialogComment = !this.dialogComment
            let flagComment = false
            if (this.dialogComment) {
                this.colorComment = 'primary'
                flagComment = false
            } else {
                this.colorComment = 'black'
                flagComment = true
            }

            if (flagComment && this.commentText !== '') {
                let date = new Date().getTime();
                let comment = this.commentText
                let nameUserComment = this.getCurrentUser.data.name
                let uidUser = this.getCurrentUser.uid

                let commentVet = this.CalledViewClick.comments

                commentVet.unshift({ uidUser, userComment: nameUserComment, time: date, comment: comment })

                let newComment = {
                    id_post: this.CalledViewClick.idDoc || this.CalledViewClick.id,
                    uidUser,
                    userComment: nameUserComment,
                    time: date,
                    comment
                }
                this.loadingComment = true
                await firebase.addCommment(newComment)
                let sizeCommentsPost = await firebase.getComments(newComment.id_post)
                await firebase.updateCalls(newComment.id_post, { comment_size: sizeCommentsPost })
                this.CalledViewClick.comment_size !== undefined ?
                    this.CalledViewClick.comment_size = sizeCommentsPost : ""
                this.loadingComment = false

                this.getUsers.filter((user) => {
                    if (user.id === uidUser) {
                        newComment = {
                            ...newComment,
                            imageUser: user.data.metadata.imageURL
                        }
                        this.commentCurrentIndex.unshift(newComment)
                    }
                })
                //this.updateComment(this.CalledViewClick.idDoc, { comments: this.CalledViewClick.comments })
            }
            this.commentText = ""
        },
        async openClalledView(index) {
            this.loadingOpenCalled = true
            this.CalledViewClick = index
            this.infiniteId += 1
            let id = this.CalledViewClick.idDoc || this.CalledViewClick.id
            let { result, list, lastDocSnapshot } = await firebase.paginationComments(
                id,
                this.lastDocSnapshotComment)
            this.lastDocSnapshotComment = lastDocSnapshot
            this.commentCurrentIndex = list
            await this.addImgComment(this.commentCurrentIndex)
            this.statusModel = this.status(this.CalledViewClick.status, "color")
            this.loadingOpenCalled = false
            this.dialogView = true
        },
        async alterStatus(alter, parans) {
            this.statusModel === "Concluído" ? this.dialogFinishCalled = true : this.dialogStatus = true

            if (alter) {
                this.loadingStatus = true
                this.CalledViewClick.status = this.status(this.statusModel, "name")
                parans ?
                    await firebase.updateCalls(this.CalledViewClick.idDoc || this.CalledViewClick.id, {
                        status: this.CalledViewClick.status,
                        solution: parans,
                    }) :
                    await firebase.updateCalls(this.CalledViewClick.idDoc || this.CalledViewClick.id, {
                        status: this.CalledViewClick.status,
                    })
                this.loadingStatus = false

                this.dialogFinishCalled = false
                this.dialogStatus = false
            } else if (alter == false) {
                this.statusModel = this.status(this.CalledViewClick.status, "color")
                this.dialogFinishCalled = false
                this.dialogStatus = false
            }
        },
        status(status, colorOrName) {
            if (colorOrName == "color") {
                switch (status) {
                    case "red":
                        return "Em Aberto";
                    case "#FF8300":
                        return "Andamento";
                    case "green":
                        return "Concluído";
                    default:
                        return null;
                }
            }
            if (colorOrName == "name") {
                switch (status) {
                    case "Em Aberto":
                        return "red";
                    case "Andamento":
                        return "#FF8300";
                    case "Concluído":
                        return "green";
                    default:
                        return null;
                }
            }
        },
        identifierGenerator(call) {

            let identifier = this.callsSizeIdentif + call.natureCalled[0]
            this.callsSizeIdentif += 1
            return identifier
        },
        closeClalledDialog() {
            this.resetNewCalled()
            this.commentCurrentIndex = []
            this.lastDocSnapshotComment = null
            this.dialogView = false
            this.dialog = false
            this.isLoadingCreate = false
        },
        isReadySelect() {
            return (
                this.clientObject !== null
            );
        },
        onChangeUnit() {
            this.selectedSector = null;
            this.listSectors = null;
            if (this.unitObject.sectors.length !== 0) {
                this.listSectors = this.unitObject.sectors;
            } else { this.listSectors = this.unitObject.name }
        },
        resetNewCalled() {
            this.CalledViewClick = { imageUser: null, nameUser: null, natureCalled: null, status: null, imageURL: null, description: null, openTime: null };
            this.objCalled = []
            this.image = this.defaultImage;
            this.clientObject = null
            this.unitObject = null
            this.selectedSector = null
            this.listUnits = null
            this.listSectors = null
        },
        async checkSave() {
            if (this.$refs.FormNewCalled && !this.$refs.FormNewCalled.validate()) {
                return;
            }

            // Parametros Auto
            this.objCalled.openTime = new Date().getTime();
            this.objCalled.user = this.getCurrentUser.uid
            this.objCalled.permissions = this.showToOptions;
            // Parametros Obrigatorios

            if (this.clientObject !== null) { this.objCalled.connections = { 'client': this.clientObject.data.name } }
            if (this.selectedSector !== null) {
                this.objCalled.connections.sector = this.selectedSector.name || this.selectedSector
            }
            if (this.unitObject !== null) { this.objCalled.connections.unit = this.unitObject.name }
            let clientUnit = await firebase.getUserbyId(this.unitObject.user)
            this.objCalled.connections.unit_id = this.unitObject.id
            let client_id = await firebase.getClientByName(this.clientObject.data.name)
            if (client_id.length > 0) {
                this.objCalled.connections.client_id = client_id[0].id
            }
            this.objCalled.connections.franchisee = clientUnit.manager
            if (this.objCalled.status == 'Concluído') this.objCalled.status = "green"
            else if (this.objCalled.status == 'Em andamento') this.objCalled.status = "yellow"
            else if (this.objCalled.status == 'Em aberto') this.objCalled.status = "red"

            this.objCalled.imageUser = this.getCurrentUser.data.metadata.imageURL
            this.objCalled.nameUser = this.getCurrentUser.data.name
            this.objCalled.identifier_OS = this.identifierGenerator(this.objCalled);

            this.save()

        },
        async save() {
            this.isLoadingCreate = true
            firebase.createCalls(this.objCalled)
                .then(response => {
                    this.callsVet.unshift(response)
                    let newVet = this.callsVet
                    this.callsVet = []
                    this.calls(newVet);
                })
                .catch(err => {
                    console.error(err)
                    alert('Erro ao salvar chamado! Entre em contato com a equipe técnica!')
                    this.isLoadingCreate = false
                })
        },
        async onChangeClient(client) {
            this.listSectors = [];
            this.isBusyPage = true;
            this.graphicButton = true;
            try {

                this.graphicButton = false;
                this.listUnits = await this.getUnitsByUser(client);
                //this.resetGraphicDialog()
                this.isBusyPage = false;
            } catch (e) {
                console.error(e)
                this.isBusyPage = false;
            }
        },
        async showTo(rank) {
            this.showToOptions = []
            this.showCheckBoxOptions = []
            switch (rank) {
                case "Super Admin":
                    this.showToOptions = { superAdmin: true, admin: false, franchisee: false, client: false, associated: false }
                    this.showCheckBoxOptions = { all: true, admin: true, franchisee: true, client: true, associated: true }
                    break;
                case "Admin":
                    this.showToOptions = { superAdmin: true, admin: true, franchisee: false, client: false, associated: false }
                    this.showCheckBoxOptions = { all: true, admin: false, franchisee: true, client: true, associated: true }
                    break;
                case "Franqueado":
                    this.showToOptions = { superAdmin: true, admin: true, franchisee: true, client: false, associated: false }
                    this.showCheckBoxOptions = { all: true, admin: false, franchisee: false, client: true, associated: true }
                    break;
                case "Cliente":
                    this.showToOptions = { superAdmin: true, admin: true, franchisee: true, client: true, associated: false }
                    this.showCheckBoxOptions = { all: true, admin: false, franchisee: false, client: false, associated: true }
                    break;
                case "Associado":
                    this.showToOptions = { superAdmin: true, admin: true, franchisee: true, client: true, associated: true }
                    this.showCheckBoxOptions = { all: false }
                    break;
                default:
                    break;
            }
            await this.usersClass(rank)
        },
        usersAvailable() {
            this.usersClassVet.superAdmin = this.getUsers.filter((i) => { return i.data.rank == 'Super Admin' })
            this.usersClassVet.admin = this.getUsers.filter((i) => { return i.data.rank == 'Admin' })
            this.usersClassVet.franchisee = this.getUsers.filter((i) => { return i.data.rank == 'Franqueado' })
            this.usersClassVet.client = this.getUsers.filter((i) => { return i.data.rank == 'Cliente' })
            this.usersClassVet.associate = this.getUsers.filter((i) => { return i.data.rank == 'Associado' })

            this.usersNames.adminNames = this.usersClassVet.admin.map((i) => { return i.data.name })
            this.usersNames.franchiseeNames = this.usersClassVet.franchisee.map((i) => { return i.data.name })
            this.usersNames.clientNames = this.usersClassVet.client.map((i) => { return i.data.name })
            this.usersNames.associatedNames = this.usersClassVet.associate.map((i) => { return i.data.name })
        },
        convertRank() {
            let rank = this.getCurrentUserRank
            switch (rank) {
                case "Super Admin":
                    rank = "superAdmin"
                    break;
                case "Admin":
                    rank = "admin"
                    break;
                case "Franqueado":
                    rank = "franchisee"
                    break;
                case "Cliente":
                    rank = "client"
                    break;
                case "Associado":
                    rank = "associated"
                    break;
                default:
                    break;
            }

            //Busca permissão de bv
            let callsFilter = []
            this.callsVet.map((i) => {
                if (i.permissions[rank] == true) {
                    callsFilter.push(i)
                    return
                }

            })
            this.callsVet = callsFilter
        },
        async usersClass(rank) {
            this.convertRank();
            let users = await firebase.getUsers()
            this.usersClassVet = []
            let idUser = null

            let callsAdminAndSuper = []
            let associatsCurrentClient = []
            let managerCliente = []
            let currentCliente = []
            let callsManagers = []
            switch (rank) {

                case "Super Admin":
                    this.usersAvailable();
                    this.callsVetView = this.callsVet
                    this.callsVetViewFilter = this.callsVetView
                    rank = "superAdmin"
                    break;
                case "Admin":
                    this.usersAvailable();
                    this.callsVetView = this.callsVet
                    this.callsVetViewFilter = this.callsVetView
                    rank = "admin"
                    break;
                case "Franqueado":
                    let callsFranchisee = []
                    idUser = this.getCurrentUser.uid
                    currentCliente = users.find((i) => { return i.id == idUser })
                    managerCliente = users.filter((i) => { return currentCliente.id == i.data.manager })

                    //callsFranchisee.filter((i)=>{})

                    callsManagers = []


                    ///////////////////////////////
                    let associateds = []
                    for (let key in managerCliente) {
                        //Buscando Calls dos clientes
                        callsManagers = this.callsVet.filter((i) => {
                            return managerCliente[key].id == i.user
                        })
                        for (let key in callsManagers) {
                            if (callsManagers[key] !== undefined) callsFranchisee.push(callsManagers[key])
                        }
                        ///////////////////////////////////////////////////////

                        associatsCurrentClient = users.filter((i) => {
                            if (i.data.client) {
                                return i.data.client == managerCliente[key].id
                            }

                        })

                        if (associatsCurrentClient.length > 0) {
                            for (let i in associatsCurrentClient) {
                                associateds.push(associatsCurrentClient[i])
                            }
                        }

                    }
                    for (let key in associatsCurrentClient) {
                        callsManagers = this.callsVet.filter((i) => {
                            return associatsCurrentClient[key].id == i.user
                        })
                        for (let key in callsManagers) {
                            if (callsManagers[key] !== undefined) callsFranchisee.push(callsManagers[key])
                        }
                    }
                    ///////////////////////////////////////
                    callsAdminAndSuper = this.callsVet.filter((i) => {

                        let user = users.find((index) => {

                            if (i.user == index.id && index.data.rank == "Admin") {
                                return true
                            } else if (i.user == index.id && index.data.rank == "Super Admin") {
                                return true
                            }
                        })

                        if (user) return user.id == i.user

                    })
                    for (let key in callsAdminAndSuper) {
                        if (callsAdminAndSuper[key] !== undefined) {
                            callsFranchisee.push(callsAdminAndSuper[key])
                        }
                    }
                    /////////////////////////////////////////
                    callsAdminAndSuper = this.callsAdminAndSuper();

                    for (let key in callsAdminAndSuper) {
                        if (callsAdminAndSuper[key] !== undefined) {
                            callsFranchisee.push(callsAdminAndSuper[key])
                        }
                    }
                    this.orderData(callsFranchisee)


                    rank = "franchisee"
                    break;
                case "Cliente":
                    let callsClient = []
                    //Se for CLIENTE ele precisa saber quem é seu franqueado
                    // Cliente vai buscar na posição manager"ID" para saber quem é seu franqueado
                    idUser = this.getCurrentUser.uid
                    this.usersNames.associatedNames = []
                    //buscando todos os chamados que o manager do cliente em callsFilter onde já estão todos os chamados referentes ao rank cliente.
                    currentCliente = users.find((i) => { return i.id == idUser })
                    managerCliente = users.find((i) => { return i.id == currentCliente.data.manager })

                    associatsCurrentClient = users.filter((i) => { return i.data.client == idUser })

                    // this.usersNames.associatedNames contem os associados desse cliente
                    this.getUsers.filter((i) => {
                        if (i.data.rank == "Associado" && i.data.client.id == idUser) {
                            this.usersNames.associatedNames.push(i.id)
                            return
                        }
                    })

                    //procura por chamados feitos pelos associados do cliente

                    for (let key in this.usersNames.associatedNames) {

                        let callAssociat = this.callsVet.filter((i) => {

                            return this.usersNames.associatedNames[key] == i.user
                        })
                        if (callAssociat.length > 0) callsClient.push(callAssociat[0])
                        callAssociat = []
                    }
                    callsManagers = []
                    callsManagers = this.callsVet.filter((i) => {
                        return managerCliente.id == i.user
                    })
                    for (let key in callsManagers) {
                        if (callsManagers[key] !== undefined) callsClient.push(callsManagers[key])
                    }

                    callsAdminAndSuper = this.callsAdminAndSuper();

                    for (let key in callsAdminAndSuper) {
                        if (callsAdminAndSuper[key] !== undefined) {
                            callsClient.push(callsAdminAndSuper[key])
                        }
                    }

                    this.orderData(callsClient)


                    rank = "client"
                    break;
                case "Associado":

                    //filtrar apenas chamados que o cliente gerente desse associado tenha feito
                    idUser = this.getCurrentUser.uid
                    let callsClients = []
                    let currentAssociated = users.find((i) => { return i.id == idUser })
                    let clientAssociated = users.find((i) => { return i.id == currentAssociated.data.client })
                    let managerClienteByAssociated = users.find((i) => { return i.id == clientAssociated.data.manager })
                    let callsManagersByAssociated = []
                    callsManagersByAssociated = this.callsVet.filter((i) => {
                        return managerClienteByAssociated.id == i.user
                    })
                    for (let key in callsManagersByAssociated) {
                        if (callsManagersByAssociated[key] !== undefined) callsClients.push(callsManagersByAssociated[key])
                    }
                    let clientCalls = []
                    clientCalls = this.callsVet.filter((i) => {
                        return clientAssociated.id == i.user
                    })
                    for (let key in clientCalls) {
                        if (clientCalls[key] !== undefined) {
                            callsClients.push(clientCalls[key])
                        }
                    }
                    let adminAndSuper = this.callsAdminAndSuper()
                    for (let key in adminAndSuper) {
                        if (adminAndSuper[key] !== undefined) {
                            callsClients.push(adminAndSuper[key])
                        }
                    }
                    this.orderData(callsClients)

                    rank = "associated"
                    break;
                default:
                    break;
            }
            this.closeClalledDialog();
            this.dialogView = false
            this.loadCalls = false
        },
        async addImgComment(call) {
            let result = []
            call.map((comment, index) => {
                this.getUsers.filter((user) => {
                    if (user.id === comment.uidUser) {
                        comment = {
                            ...comment,
                            imageUser: user.data.metadata.imageURL
                        }
                        call[index] = comment
                    }
                })
            })

        },
        orderData(calls) {
            if (calls) {
                function compare(a, b) {
                    return b.openTime - a.openTime;
                }
                this.callsVetView = calls.sort(compare)
            }
            this.callsVetViewFilter = this.callsVetView
        },
        callsAdminAndSuper() {
            let idUser = this.getCurrentUser.uid
            let callsAdminAndSuper = this.callsVet.filter((i) => {

                let user = this.getUsers.find((index) => {

                    if (i.user == index.id && index.data.rank == "Admin") {
                        return true
                    } else if (i.user == index.id && index.data.rank == "Super Admin") {
                        return true
                    }
                })

                if (user) return user.id == i.user

            })

            let postsCurrenteUser = this.callsVet.filter((i) => { return i.user == idUser })
            for (let key in postsCurrenteUser) {
                if (postsCurrenteUser[key] !== undefined) callsAdminAndSuper.push(postsCurrenteUser[key])
            }

            return callsAdminAndSuper
        },
        viewMD(img) {
            if (img == null) return 12
            else return 4
        },
        addRankCall() {
            for (let key in this.callsVet) {
                for (let i in this.getUsers) {
                    if (this.getUsers[i].id == this.callsVet[key].user) {
                        this.callsVet[key].rankUser = this.getUsers[i].data.rank
                    }
                }
            }
        },
        pickFile() {
            this.$refs.image.click();
        },
        onFilePicked(e) {
            this.imageUploadError = undefined;

            const files = e.target.files;

            if (
                files[0] !== undefined &&
                files[0].type.split("/")[0] == "image" &&
                files[0].size < 700000
            ) {
                this.objCalled.imageName = files[0].name;

                if (this.objCalled.imageName.lastIndexOf(".") <= 0) {
                    return;
                }
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener("load", () => {
                    this.objCalled.imageURL = fr.result;
                    this.image = fr.result;
                    this.imageFile = files[0]; // this is an image file that can be sent to server...
                });
            } else if (files[0].size > 699999) {
                this.imageUploadError = "Tamanho máximo: 700 KB.";
                this.image = this.defaultImage;
                this.objCalled.imageURL = "";
                this.objCalled.imageName = "";
            } else {
                this.imageUploadError = "Arquivo inválido.";
                this.image = this.defaultImage;
                this.objCalled.imageURL = "";
                this.objCalled.imageName = "";
            }
        },
        async viewPostRank(calls) {

            //calls getcalls
            //rank do usuario atual this.getCurrentUserRank
            let rank = this.getCurrentUserRank
            switch (rank) {
                case "Super Admin":
                    rank = "superAdmin"
                    break;
                case "Admin":
                    rank = "admin"
                    break;
                case "Franqueado":
                    rank = "franchisee"
                    break;
                case "Cliente":
                    rank = "client"
                    break;
                case "Associado":
                    rank = "associated"
                    break;
                default:
                    break;
            }

            //Busca permissão de bv
            let callsFilter = []
            calls.map((i) => {
                if (i.permissions[rank] == true) {
                    callsFilter.push(i)
                    return
                }

            })
            this.callsVet = callsFilter

            //Verificando dependencias do rank
            let maneger = null
            let idClient = null
            let callsClientAndAssociated = []

            if (rank == "franchisee") {
                let users = await firebase.getUsers()
                let clients = this.getUsers
                let associats = []
                let calledUser = []
                idClient = this.getCurrentUser.uid

                for (let key in this.callsVet) {
                    for (let i in users) {
                        if (users[i].id == this.callsVet[key].user) {
                            this.callsVet[key].rankUser = users[i].data.rank
                        }
                    }
                }

                for (let key in clients) {
                    associats = users.filter((i) => {
                        if (i.data.rank == "Associado" && clients[key].id == i.data.client) {
                            return i
                        }
                    })
                }
                for (let key in associats) {
                    calledUser = this.callsVet.filter((i) => {
                        if (i.user == associats[key].id) return i

                    })
                }
                for (let key in clients) {
                    this.callsVet.filter((i) => {
                        if (i.user == clients[key].id) return calledUser.push(i)
                        else if (i.user == idClient) return calledUser.push(i)
                        else if (i.rankUser == "Super Admin" || i.rankUser == "Admin") {

                            return calledUser.push(i)
                        }
                    })
                }
                this.callsVet = calledUser
            }
            else if (rank == "client") {
                //Se for CLIENTE ele precisa saber quem é seu franqueado
                // Cliente vai buscar na posição manager"ID" para saber quem é seu franqueado
                maneger = this.getCurrentUser.data.manager
                idClient = this.getCurrentUser.uid
                //buscando todos os chamados que o manager do cliente em callsFilter onde já estão todos os chamados referentes ao rank cliente.
                //precisando buscar os associados do usuario para fazar a comparação se existe chamados deles.
                //-------------------- this.callsVet
                let associatsClient = this.getUsers.filter((i) => {
                    if (i.data.rank == "Associado" && i.data.client.id == idClient) {
                        return i
                    }
                })
                //this.getUsers    

                let teste = []
                for (let key in associatsClient) {
                    this.callsVet = this.callsVet.filter((i) => {
                        if (i.user == associatsClient[key].id && i.rankUser == "Associado") {
                            return i
                        } else if (i.user == maneger && i.rankUser == "Franqueado") {
                            return i
                        } else if (i.rankUser == "Super Admin" || i.rankUser == "Admin") {
                            return i
                        }

                    })
                }

                callsFilter.map((i) => {
                    if (i.user == maneger) {
                        callsClientAndAssociated.push(i)
                        return
                    }
                })

            } else if (rank == "associated") {
                //Se for ASSOCIADO ele precisa saber quem é seu CLIENTE
                // Associado vai buscar na posição client"ID" para saber quem é seu cliente


            }

        },
    },
    computed: {
        ...mapGetters([
            "optionsDialogAlert",
            "getUsers",
            "getCurrentUser",
            "getCurrentUserRank",
            "getClients",
            'isLoadingUsers',
            'isLoadingUnits',
        ]),
        ...LoadingReport['computed'],
        filteredItems() {

            return this.callsVetView;
        },
        rulesRequired() {
            return Rules.required();
        },
        RulesCharacters() {
            return Rules.string(true, 50, 500);
        },
    },
    created() {
        const callsSize = async () => {
            this.callsSizeIdentif = await firebase.callsSize()
            this.callsSizeIdentif = this.callsSizeIdentif[0].identifier_OS.replace(/([^\d])+/gim, '')
            this.callsSizeIdentif = Number(this.callsSizeIdentif) + 1
        }
        callsSize()
    },
    watch: {
        async whereFilterSelectCalls() {
            this.showInfiniteLoading = false
            if (this.whereFilterSelectCalls) {
                this.callsVet = []
                this.callsVetView = this.callsVet
                const { calls, lastDocSnapshot } = await firebase.paginationCalls(null, this.whereFilterSelectCalls)
                this.lastDocSnapshot = lastDocSnapshot
                this.showInfiniteLoading = true
                await this.calls(calls)
            } else {
                this.callsVet = []
                this.callsVetView = this.callsVet
                const { calls, lastDocSnapshot } = await firebase.paginationCalls(null)
                this.lastDocSnapshot = lastDocSnapshot
                this.showInfiniteLoading = true
                await this.calls(calls)
            }
        }
    },
    mounted() {

    },
}

